import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Contact Me`}</h3>
    <div style={{
      padding: '20px'
    }}>
      <p><a parentName="p" {...{
          "href": "https://www.linkedin.com/in/yonatangross/"
        }}><img align="left" alt="yonatangross | LinkedIn" height="40px" src="https://www.flaticon.com/svg/static/icons/svg/1383/1383262.svg" /></a>{`
`}<a parentName="p" {...{
          "href": "mailto:yonatan2gross@gmail.com"
        }}><img align="left" alt="yonatan2gross | Gmail" height="40px" src="https://www.flaticon.com/svg/static/icons/svg/281/281786.svg" /></a>{`
`}<a parentName="p" {...{
          "href": "https://www.dropbox.com/s/slh8ubgjnq4b1is/Yonatan%20Gross%20-%20CV.pdf"
        }}><img align="left" alt="yonatangross | Resume" height="40px" src="https://i.ibb.co/3WW9dHp/cv.png" download /></a></p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      